import * as ActionTypes from './types';
import { Schemas } from '../models/entities';

const authenticate = (email, password, rememberMe) => ({
  [ActionTypes.AUTHENTICATE]: {
    types: [
      ActionTypes.LOGIN_REQUEST,
      ActionTypes.LOGIN_SUCCESS,
      ActionTypes.LOGIN_FAILURE,
    ],
    username: email,
    password,
    rememberMe,
  },
});

export const login = (email, password, rememberMe) => (dispatch) => (
  dispatch(authenticate(email, password, rememberMe))
);

const fetchProfile = () => ({
  [ActionTypes.API_CALL]: {
    method: 'GET',
    types: [
      ActionTypes.FETCH_PROFILE_REQUEST,
      ActionTypes.FETCH_PROFILE_SUCCESS,
      ActionTypes.FETCH_PROFILE_FAILURE,
    ],
    schema: Schemas.USER,
    endpoint: '/api/me',
  },
});

export const loadProfile = () => (dispatch) => (
  dispatch(fetchProfile())
);

export const logout = () => (dispatch) => (dispatch({ type: ActionTypes.LOGOUT_SUCCESS }));

const doChangePassword = (userId, currentPassword, newPassword) => ({
  [ActionTypes.API_CALL]: {
    method: 'PUT',
    types: [
      ActionTypes.CHANGE_PASSWORD_REQUEST,
      ActionTypes.CHANGE_PASSWORD_SUCCESS,
      ActionTypes.CHANGE_PASSWORD_FAILURE,
    ],
    schema: Schemas.USER_ARRAY,
    endpoint: `/api/users/${userId}/change-password`,
    body: {
      currentPassword,
      newPassword,
    },
  },
});

export const changePassword = (
  userId,
  currentPassword,
  newPassword,
) => (dispatch) => dispatch(doChangePassword(userId, currentPassword, newPassword));
